import { faArrowProgress } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export function EmptyCard() {
  const { t } = useTranslation();

  return (
    <div className="w-full h-full bg-white rounded-md p-8 flex flex-col justify-center items-center gap-3">
      <FontAwesomeIcon
        className="text-neutrals-700"
        icon={faArrowProgress}
        size="2x"
      />
      <div>
        {t('domain.mitarbeiter.rotationsplan.rotationsplaene.keinPlan.title')}
      </div>
      <div className="text-neutrals-700 text-sm text-center">
        {t(
          'domain.mitarbeiter.rotationsplan.rotationsplaene.keinPlan.subtitle',
        )}
      </div>
    </div>
  );
}
